import React, { memo } from 'react';
import { FormattedMessage } from 'react-intl';
import moment from 'moment';
import {
  StatusBox, StatusBoxWithCheckmark,
} from 'components';
import './styles/Information.scss';

interface Props {
  handleChangeAgreementsStatus,
  handleChangeAdminStatus,
  showResultAgreements?:boolean,
  labelTransID?:string,
  agreements?:any,
  isSign?:boolean,
  overallStatus?:string,
  isDisabled?: boolean,
}

const Retail: React.FC<Props> = memo((props) => {
  const {
    agreements: {
      agreements,
      signedStatus,
      adminStatus,
      result,
    }, isSign,
    handleChangeAgreementsStatus = () => {},
    handleChangeAdminStatus = () => {},
    labelTransID,
    showResultAgreements,
    isDisabled,
  } = props;
  const agreementStatus = agreements && agreements.status;
  return (
    <div className="formsApp__content__list">

      <div className="formsApp__content__list__item">
        <StatusBoxWithCheckmark
          status={agreementStatus || null}
          isWaiting={false}
        />
      </div>

      {/* Signed status */}
      <div className="formsApp__content__list__item isChild">
        <StatusBoxWithCheckmark
          isWaiting={!isSign}
          status={signedStatus && signedStatus.status ? signedStatus.status : null}
          statusDetail={(
            <FormattedMessage
              key="showAgreements11111"
              id="manageApplication.signedByClientOn"
              values={{
                span: (...chunks) => <span>{chunks}</span>,
                b: (...chunks) => <b>{chunks}</b>,
                date: moment(signedStatus
                  && signedStatus.statusDetail).format('DD MMM YYYY'),
              }}
            />
          )}
        />
      </div>

      {/*  Admin Status : Retail */}
      {isSign && (
      <div className="formsApp__content__list__item isChild">

        <StatusBox
          title={adminStatus && adminStatus.title}
          status={adminStatus && adminStatus.status}
          onStatusChange={handleChangeAgreementsStatus}
          isDropdown={isSign}
          isDropDownValue={isSign}
          isDisabled={isDisabled}
          statusDetail={(
            <FormattedMessage
              key={labelTransID}
              id={labelTransID}
              values={{
                b: (...chunks) => <b>{chunks}</b>,
                date: moment(adminStatus && adminStatus.statusDetails).format('DD MMM YYYY'),
              }}
            />
          )}
        />
      </div>
      )}

      {/*  result Status : Retail */}
      {showResultAgreements && (
      <div className="formsApp__content__list__item isChild">
        <StatusBox
          onStatusChange={handleChangeAdminStatus}
          isDropdown={showResultAgreements}
          isSuccess={showResultAgreements}
          statusDetail={(
            <FormattedMessage
              key="showAgreements1"
              id="manageApplication.ApprovedOnBy"
              values={{
                span: (...chunks) => <span>{chunks}</span>,
                b: (...chunks) => <b>{chunks}</b>,
                date: moment(result.statusDetail).format('DD MMM YYYY'),
                user: result.updatedBy,
              }}
            />
          )}
        />
      </div>
      )}

    </div>
  );
});

export default Retail;
